module.exports = __webpack_public_path__ + "static/media/slika2.2d4f15e4.png";